import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AlertController, IonButton, IonButtons, IonHeader, IonIcon, IonTitle, IonToolbar, ModalController } from '@ionic/angular/standalone';
import { Store } from '@ngrx/store';
import { ButtonComponent } from 'src/app/components/button/button.component';
import { ItemInputComponent } from 'src/app/components/item-input/item-input.component';
import { ItemLabelComponent } from 'src/app/components/item-label/item-label.component';
import { ItemComponent } from 'src/app/components/item/item.component';
import { AppState } from 'src/app/store/reducers';
import { createSheetTemplateFromSheetRequested } from 'src/app/store/sheet/sheet.actions';

@Component({
    templateUrl: './create-sheet-template.modal.html',
    styleUrl: './create-sheet-template.modal.scss',
    imports: [
        IonHeader, IonToolbar, IonTitle, IonButtons, IonButton, IonIcon, ItemComponent, ItemLabelComponent, ItemInputComponent, ButtonComponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CreateSheetTemplateModal {

	@Input() sheetId!: string;

	templateName: string | null = null;

	private saveTemplateClicked: boolean = false; // without this, it is possible to click twice

	constructor(private store: Store<AppState>, private modalController: ModalController, private alertController: AlertController) {
	}

	nameChanged(name: string) {
		this.templateName = name.trim();
	}

	async saveTemplate() {
		if (this.saveTemplateClicked) return;
		this.saveTemplateClicked = true;

		if (!this.templateName || this.templateName.trim() === '') {
			this.presentAlert('You must enter a template name');
			return;
		}

		await this.close();
		this.store.dispatch(createSheetTemplateFromSheetRequested({ sheetId: this.sheetId, templateName: this.templateName }));
	}

	close() {
		return this.modalController.dismiss();
	}

	private async presentAlert(message: string) {
		const alert = await this.alertController.create({
			message,
			buttons: ['Ok'],
			backdropDismiss: false
		});
		alert.present();
	}
}
